import { Modelo } from '@ext/index';
import * as Types from './Pregunta.types';
import moment, { Moment } from 'moment';
import { Opcion } from '@/__env/lib/Cursos/Preguntas/Opciones';
import { isArray } from 'util';

export class IPregunta extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Curso: number = 0;
    public Posicion: number = 0;
    public Tipo: Types.Tipos = Types.Tipos.Unica;
    public Pregunta: string = '';

    public Opciones: Opcion[] = [];


    public getJson(): any
    {
        let json: any = {};

        json.tipo = this.Tipo.Id;
        json.pregunta = this.Pregunta;
        json.posicion = this.Posicion;
        json.opciones = this.Opciones.map( x => x.getJson() );

        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Curso = !this.Json.curso ? 0 : this.Json.curso;
        this.Posicion = !this.Json.posicion ? 0 : this.Json.posicion;
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );
        this.Pregunta = !this.Json.pregunta ? '' : this.Json.pregunta;

        if ( isArray( this.Json.opciones ) )
        {
            for ( let e of this.Json.opciones )
            {
                this.Opciones.add( new Opcion( e ) );
            }
        }


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IPregunta )
    {
        this.Model = Model;
    }

    public Model: IPregunta;
}